import { render, staticRenderFns } from "./PocComponent.vue?vue&type=template&id=dfb1272c&"
import script from "./PocComponent.vue?vue&type=script&lang=js&"
export * from "./PocComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports